import { vars } from 'src/core/themes';

import { PosIconProps, SvgWrapper } from './SvgWrapper';

const DefaultIconSize = 16;

export function TableSortingIconV2({
  width,
  height,
  isActive,
  ...props
}: PosIconProps & {
  isActive?: boolean;
}) {
  const stroke = vars.color.backgroundBrand;

  // Size should have higher priority overridding the width and height
  const sanitizedWidth = props.size ? undefined : (width ?? DefaultIconSize);
  const sanitizedHeight = props.size ? undefined : (height ?? DefaultIconSize);

  return (
    <SvgWrapper
      {...props}
      width={sanitizedWidth}
      height={sanitizedHeight}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 4.99976L11 7.99976M8 4.99976V11M8 4.99976L5 7.99976"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
}
